import { CHECK_STATUS } from '../types';
import abortAfter from './abortAfter';

export const id = 'drmLicenseReachability';
export const label = 'DRM License Reachability';

const TIMEOUT_MS = 8000;

export async function run(ctx) {
  const start = Date.now();

  const probeUplynk = async () => {
    const res = await fetch('https://content.uplynk.com/wv', {
      signal: abortAfter(TIMEOUT_MS),
    });
    if (res.status !== 200) {
      throw new Error(`uplynk returned HTTP ${res.status}`);
    }
    return true;
  };

  const probeEzdrm = async () => {
    const res = await fetch('https://widevine-dash.ezdrm.com/proxy', {
      signal: abortAfter(TIMEOUT_MS),
    });
    if (res.status !== 200) {
      throw new Error(`ezdrm returned HTTP ${res.status}`);
    }
    const body = await res.text();
    if (body.trim() !== 'HTTP Get Method Not Supported') {
      throw new Error(`ezdrm unexpected body: ${body.slice(0, 80)}`);
    }
    return true;
  };

  const [uplynkResult, ezdrmResult] = await Promise.allSettled([
    probeUplynk(),
    probeEzdrm(),
  ]);

  const durationMs = Date.now() - start;

  const uplynkOk = uplynkResult.status === 'fulfilled';
  const ezdrmOk = ezdrmResult.status === 'fulfilled';

  if (uplynkOk && ezdrmOk) {
    return {
      id,
      label,
      status: CHECK_STATUS.PASS,
      detail: 'DRM license endpoints reachable',
      detailData: { uplynk: 'ok', ezdrm: 'ok' },
      durationMs,
    };
  }

  if (!uplynkOk && !ezdrmOk) {
    return {
      id,
      label,
      status: CHECK_STATUS.FAIL,
      detail: 'DRM endpoints unreachable',
      detailData: { uplynk: 'failed', ezdrm: 'failed' },
      durationMs,
    };
  }

  if (!uplynkOk) {
    return {
      id,
      label,
      status: CHECK_STATUS.FAIL,
      detail: 'Uplynk endpoint unreachable',
      detailData: {
        uplynk: 'failed',
        ezdrm: 'ok',
        error: uplynkResult.reason?.message,
      },
      durationMs,
    };
  }

  return {
    id,
    label,
    status: CHECK_STATUS.FAIL,
    detail: 'EZDRM endpoint unreachable',
    detailData: {
      uplynk: 'ok',
      ezdrm: 'failed',
      error: ezdrmResult.reason?.message,
    },
    durationMs,
  };
}
